
export const featuredProducts = [
  {
    id: 1,
    title: "ULTRA Q",
    image: "/images/machines/1.png"
  },
  {
    id: 2,
    title: "GENELUX-3",
    image: "/images/machines/2.png"
  },
  {
    id: 3,
    title: "DIODE HAIR REMOVAL",
    image: "/images/machines/3.png"
  },
  {
    id: 4,
    title: "MEDI LIFT HIFU Machine",
    image: "/images/machines/4.png"
  },
  {
    id: 5,
    title: "ULTRAFRAX CO2 FRACTIONAL",
    image: "/images/machines/5.png"
  },
  {
    id: 6,
    title: "ALLICE BUBBLE HYDRA FACIAL MACHINE",
    image: "/images/machines/6.png"
  },


  {
    id: 6,
    title: "650NM HAIR REGROWTH PANEL",
    image: "/images/machines/36.png"
  },
  {
    id: 6,
    title: "PRO MNRF",
    image: "/images/machines/34.png"
  }
];
